import script from "./TransitionQst.vue?vue&type=script&setup=true&lang=js"
export * from "./TransitionQst.vue?vue&type=script&setup=true&lang=js"

import "./TransitionQst.vue?vue&type=style&index=0&id=35659595&lang=scss"

const __exports__ = script;

export default __exports__